import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.js';
import { applyDocumentLocale, initI18n, normaliseLocale } from './i18n/config.js';
import { loadAnalytics } from './lib/analytics.js';
import './styles/tokens.css';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}

// Translations must be loaded before the first paint, otherwise the page
// renders raw keys for a frame.
const i18n = await initI18n();

// Direction too: index.html declares none, so applying this only from a React
// effect would mirror the layout after the first paint is already on screen.
applyDocumentLocale(normaliseLocale(i18n.resolvedLanguage), document.documentElement);

// After the locale is applied, so the tracker records the page as the visitor
// sees it. A no-op unless both Umami variables were present at build time.
loadAnalytics();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
